module.exports = __webpack_public_path__ + "media/icons/close-widget-294241a0.svg";